import React, { useState } from "react"
import "./styles.scss"
import SectionHeader from "../../molecules/SectionHeader"
import Title from "../../atoms/Title"
import ServicesList from "../../molecules/ServicesList"
import CTA from "../../atoms/CTA"

const ProjectSingle = ({ project, delay, isDesktop }) => {
  const [activeImage, setActiveImage] = useState(0)
  const [active, setActive] = useState(false)

  function changeImage(e) {
    const numOfImages = e.target.parentElement.children.length
    const elementWidth = e.target.clientWidth
    const columnWidth = elementWidth / numOfImages
    const rect = e.target.getBoundingClientRect()
    let x = e.clientX - rect.left
    let result = Math.floor(x / columnWidth)
    if (result < numOfImages) {
      setActiveImage(result)
    }
  }
  return (
    <li
      onClick={() => setActive(!active)}
      className={`project ${project.showCover ? "isCover" : ""} ${
        project.showCover && active ? "active" : ""
      }`}
    >
      {!project.showCover ? (
        <>
          {!project.caseStudyExternalUrl ? (
            <CTA to={project.customUrl}>
              <div
                onMouseLeave={() => setActiveImage(0)}
                onMouseMove={e => changeImage(e)}
                className="project__images"
              >
                {isDesktop &&
                  project.imagesForProjectListing.map(({ image }, i) => {
                    return (
                      <img
                        key={i}
                        src={image?.childImageSharp?.fluid?.src}
                        alt=""
                        className={`project__image ${
                          activeImage === i ? "active" : ""
                        }`}
                      />
                    )
                  })}
                {!isDesktop && (
                  <img
                    src={
                      project?.imagesForProjectListing[0]?.image
                        ?.childImageSharp?.fluid?.src
                    }
                    alt=""
                    className="project__image active"
                  />
                )}
              </div>
              <div className="project__header">
                <div className="project__details">
                  <span>{project?.title}</span>
                  <span>{project.industries?.[0]}</span>
                </div>
                <Title className="project__title" type="h3">
                  {project.caseStudyTitleText || project.title}
                </Title>
              </div>
              {project.services && (
                <ServicesList
                  services={project.services}
                  isDesktop={isDesktop}
                />
              )}
            </CTA>
          ) : (
            <a target="_blank" href={project.caseStudyExternalUrl}>
              <div
                onMouseLeave={() => setActiveImage(0)}
                onMouseMove={e => changeImage(e)}
                className="project__images"
              >
                {isDesktop &&
                  project.imagesForProjectListing.map(({ image }, i) => {
                    return (
                      <img
                        key={i}
                        src={image?.childImageSharp?.fluid?.src}
                        alt=""
                        className={`project__image ${
                          activeImage === i ? "active" : ""
                        }`}
                      />
                    )
                  })}
                {!isDesktop && (
                  <img
                    src={
                      project?.imagesForProjectListing[0]?.image
                        ?.childImageSharp?.fluid?.src
                    }
                    alt=""
                    className="project__image active"
                  />
                )}
              </div>
              <div className="project__header">
                <div className="project__details">
                  <span>{project?.title}</span>
                  <span>{project.industries?.[0]}</span>
                </div>
                <Title className="project__title" type="h3">
                  <span>
                    {project.caseStudyTitleText || project.title}
                    <span className="icon--external">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 20 20"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <title>Check it live</title>
                        <g
                          id="icon/arrow-left"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <polygon
                            id="vector"
                            fill="#000000"
                            points="19.70024 8.95491439 4.96960026 8.95491439 9.46225733 4.46326026 7.99899706 3 1 10 7.99899706 17 9.46225733 15.5367397 4.96960026 11.0450856 19.70024 11.0450856"
                          ></polygon>
                        </g>
                      </svg>
                    </span>
                  </span>
                </Title>
              </div>
              {project.services && (
                <ServicesList
                  services={project.services}
                  isDesktop={isDesktop}
                />
              )}
            </a>
          )}
          {!project?.caseStudyExternalUrl ? (
            <CTA className="btn--bordered" to={project.customUrl}>
              Case Study
            </CTA>
          ) : (
            <a
              target="_blank"
              className="btn--bordered btn btn--external"
              href={project?.caseStudyExternalUrl}
            >
              Check It Live
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <title>Check it live</title>
                <g
                  id="icon/arrow-left"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <polygon
                    id="vector"
                    fill="#000000"
                    points="19.70024 8.95491439 4.96960026 8.95491439 9.46225733 4.46326026 7.99899706 3 1 10 7.99899706 17 9.46225733 15.5367397 4.96960026 11.0450856 19.70024 11.0450856"
                  ></polygon>
                </g>
              </svg>
            </a>
          )}
        </>
      ) : (
        <>
          <div
            onMouseLeave={() => setActiveImage(0)}
            onMouseMove={e => changeImage(e)}
            className="project__images"
          >
            {isDesktop &&
              project.imagesForProjectListing.map(({ image }, i) => {
                return (
                  <img
                    key={i}
                    src={image?.childImageSharp?.fluid?.src}
                    alt=""
                    className={`project__image ${
                      activeImage === i ? "active" : ""
                    }`}
                  />
                )
              })}
            {!isDesktop && (
              <img
                src={
                  project.imagesForProjectListing[0]?.image?.childImageSharp
                    ?.fluid?.src
                }
                alt=""
                className="project__image active"
              />
            )}
            {!isDesktop && (
              <>
                <div className="project__in-progress-text">
                  Case study in progress
                </div>
                <div className="project__in-progress-overlay"></div>
              </>
            )}
          </div>
          <div className="project__header">
            <div className="project__details">
              <span>{project?.title}</span>
              <span>{project.industries?.[0]}</span>
            </div>
            <Title className="project__title" type="h3">
              {project.caseStudyTitleText || project.title}
            </Title>
          </div>
          {project.services && (
            <ServicesList services={project.services} isDesktop={isDesktop} />
          )}
          <div className="project__in-progress">In progress</div>
        </>
      )}
    </li>
  )
}

export default ProjectSingle
